import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  FormLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormHelperText,
  Tooltip,
  IconButton
} from '@mui/material';
import DatePicker from 'react-datepicker';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import FormField from '../Recruteur/candidat/AddTalent/FormField';
import ChipInput from './ChipInput';
import PhoneChipInput from './PhoneChipInput';
import ChipSelectInput from './ChipSelectInput';
import { CurrencySelect } from '../Recruteur/candidat/AddTalent/CurrencySelect';
import './DynamicForm.css';

export default function DynamicForm({
  fields,
  formData,
  setFormData,
  errors,
  setErrors,
  onNext,
  onBack,
  onSubmit,
  additionalProps = {}
}) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => setNestedValue(prev, name, value));
  };

  const handleFileChange = (fieldName, file) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: [file],
    }));
  };

  const handleDateChange = (date, name) => {
    setFormData((prev) => ({ ...prev, [name]: date }));
    setErrors((prev) => ({ ...prev, [name]: date ? '' : 'Veuillez remplir ce champ' }));
  };

  function getNestedValue(obj, path) {
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
  }

  function setNestedValue(obj, path, value) {
    const keys = path.split('.');
    const lastKey = keys.pop();
    const newObj = { ...obj };
    let current = newObj;

    keys.forEach(key => {
      if (!current[key]) current[key] = {};
      current = current[key];
    });

    current[lastKey] = value;
    return newObj;
  }

  return (
    <form className="dynamic-form">
      <div className="form-grid">
        {fields.map((field) => {
          if (field.showCondition && !field.showCondition(formData)) return null;

          return (
            <div
              key={field.name || field.label}
              className={`form-group ${field.fullWidth ? 'full-width' : ''}`}
            >
              {field.sectionTitle && <h4 className="section-title">{field.sectionTitle}</h4>}

              {['text', 'textarea'].includes(field.type) && (
                <FormField
                  label={field.label}
                  type={field.type}
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  error={errors[field.name]}
                />
              )}

              {field.type === 'radio' && (
                <FormControl component="fieldset" fullWidth margin="normal">
                  <FormLabel component="legend">{field.label}</FormLabel>
                  <RadioGroup
                    row
                    name={field.name}
                    value={formData[field.name] || ''}
                    onChange={handleChange}
                  >
                    {(field.options || []).map((option, idx) => (
                      <FormControlLabel
                        key={idx}
                        value={option.value}
                        control={<Radio />}
                        label={option.label}
                      />
                    ))}
                  </RadioGroup>
                  {errors[field.name] && <FormHelperText error>{errors[field.name]}</FormHelperText>}
                </FormControl>
              )}

              {field.type === 'chip' && (
                <ChipInput
                  label={field.label}
                  values={Array.isArray(formData[field.name]) ? formData[field.name] : [formData[field.name]].filter(Boolean)}
                  onChange={(newValues) =>
                    setFormData((prev) => ({ ...prev, [field.name]: newValues }))
                  }
                  error={!!errors[field.name]}
                  suggestions={field.suggestions || []}
                  helperText={errors[field.name]}
                  onInputChange={field.onInputChange}
                />
              )}

              {field.type === 'chip-select' && (
                <ChipSelectInput
                  label={field.label}
                  values={Array.isArray(formData[field.name]) ? formData[field.name] : []}
                  onChange={(newValues) =>
                    setFormData((prev) => ({ ...prev, [field.name]: newValues }))
                  }
                  options={field.options || []}
                  error={!!errors[field.name]}
                  helperText={errors[field.name]}
                />
              )}

              {field.type === 'chip-phone' && (
                <PhoneChipInput
                  values={Array.isArray(formData[field.name]) ? formData[field.name] : [formData[field.name]].filter(Boolean)}
                  onChange={(newValues) =>
                    setFormData((prev) => ({ ...prev, [field.name]: newValues }))
                  }
                  error={!!errors[field.name]}
                  helperText={errors[field.name]}
                />
              )}

              {field.type === 'file' && (
                <>
                  <FormField
                    label={field.label}
                    name={field.name}
                    type="file"
                    onChange={(e) => handleFileChange(field.name, e.target.files[0])}
                    error={errors[field.name]}
                  />
                  {field.showFileName && formData[field.name] && (
                    <p className="file-name">
                      {formData[field.name].name}
                    </p>
                  )}
                </>
              )}

              {field.type === 'languageList' && Array.isArray(formData[field.name]) && (
                <>
                  {formData[field.name].map((item, index) => (
                    <div className={`form-group langue-wrapper  ${field.fullWidth ? 'full-width' : ''}`}>
                    <div className="form-grid langue-grid" key={index}>
                      <FormField
                        label={index === 0 ? "Langue" : ""}
                        type="select"
                        name={`langue_${index}`}
                        value={item.langue || ""}
                        onChange={(e) => additionalProps.handleLangueChange(index, "langue", e.target.value)}
                        options={(field.options?.languages) || []}
                        containerClass="langue-field"
                      />
                      <FormField
                        label={index === 0 ? "Niveau" : ""}
                        type="select"
                        name={`niveauLangue_${index}`}
                        value={item.niveau || ""}
                        onChange={(e) => additionalProps.handleLangueChange(index, "niveau", e.target.value)}
                        options={(field.options?.levels) || []}
                        containerClass="langue-field"
                      />
                      <Tooltip title="Supprimer cette langue">
                        <IconButton
                          onClick={() => additionalProps.removeLangue(index)}
                          color="error"
                          className="delete-langue-btn"
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                        <Tooltip title="Ajouter une langue">
                          <IconButton
                            onClick={additionalProps.ajouterLangue}
                            color="primary"
                            className="add-langue-btn"
                            size="small"
                          >
                            <AddIcon />
                          </IconButton>
                        </Tooltip>
                    </div>
                  </div>                  
                  ))}
                </>
              )}

              {field.type === 'remuneration' && (
                <div className="input-currency-wrapper">
                  <FormField
                    label={field.label}
                    name={field.name}
                    type="number"
                    value={getNestedValue(formData, field.name) || ''}
                    onChange={(e) => {
                      const updated = setNestedValue(formData, field.name, e.target.value);
                      setFormData(updated);
                    }}
                    error={errors[field.name]}
                  />
                  <CurrencySelect value={additionalProps.devise} onChange={additionalProps.setDevise} />
                </div>
              )}

              {field.type === 'certificatList' && Array.isArray(formData[field.name]) && (
                <>
                  {formData[field.name].map((cert, index) => (
                    <div
                      className={`form-group certificat-wrapper ${field.fullWidth ? 'full-width' : ''}`}
                      key={index}
                    >
                      <div className="form-grid langue-grid">
                        <FormField
                          label={index === 0 ? "Titre de la certification" : ""}
                          type="text"
                          name={`certificats.${index}.title`}
                          value={cert.title || ""}
                          onChange={(e) => additionalProps.handleCertificatChange(index, "title", e.target.value)}
                          containerClass="certificat-field"
                        />
                        <FormField
                          label={index === 0 ? "Date d'obtention" : ""}
                          type="text"
                          name={`certificats.${index}.date`}
                          value={cert.date || ""}
                          onChange={(e) => additionalProps.handleCertificatChange(index, "date", e.target.value)}
                          containerClass="certificat-field"
                        />
                        <Tooltip title="Supprimer ce certificat">
                          <IconButton
                            onClick={() => additionalProps.removeCertificat(index)}
                            color="error"
                            className="delete-certificat-btn"
                            size="small"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                        {index === formData[field.name].length - 1 && (
                          <Tooltip title="Ajouter un certificat">
                            <IconButton
                              onClick={additionalProps.ajouterCertificat}
                              color="primary"
                              className="add-certificat-btn"
                              size="small"
                            >
                              <AddIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              )}

              {field.type === 'select' && (
                <FormControl fullWidth margin="dense">
                  <InputLabel id={`${field.name}-label`}>{field.label}</InputLabel>
                  <Select
                    labelId={`${field.name}-label`}
                    name={field.name}
                    value={formData[field.name] || ''}
                    onChange={additionalProps[field.name + 'Handler'] || handleChange}
                  >
                    <MenuItem value="" disabled>-- Sélectionnez --</MenuItem>
                    {(field.options || []).map((opt, idx) => (
                      <MenuItem key={idx} value={typeof opt === 'string' ? opt : opt.value}>
                        {typeof opt === 'string' ? opt : opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              {field.type === 'date' && (
                <FormControl fullWidth>
                  <DatePicker
                    selected={formData[field.name] || null}
                    onChange={(date) => handleDateChange(date, field.name)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Choisir une date"
                    customInput={
                      <TextField
                        fullWidth
                        label={field.label}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]}
                      />
                    }
                  />
                </FormControl>
              )}

              {field.type === 'custom' && typeof field.render === 'function' && (
                <div className="form-group">
                  {field.render()}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="form-buttons">
        {onBack && <Button variant="outlined" color="primary" onClick={onBack}>Étape précédente</Button>}
        {onNext && <Button variant="contained" color="primary" onClick={onNext}>Étape suivante</Button>}
        {onSubmit && <Button variant="contained" color="success" onClick={onSubmit}>Valider</Button>}
      </div>
    </form>
  );
}
